
/* Menu ordi facon cuure : ouverture au survol, sous-panneau Boutique */
(function () {
  if (!window.matchMedia('(min-width: 769px)').matches) return;
  var items = document.querySelectorAll('.gc-item'), timer = null;
  var dim = document.createElement('div'); dim.className = 'gc-dim'; document.body.appendChild(dim);
  function syncDim() {
    var open = document.querySelector('.gc-item.is-open');
    if (open) { var h = document.querySelector('.desktop-header-first-floor'); dim.style.top = (h ? Math.max(0, h.getBoundingClientRect().bottom) : 0) + 'px'; }
    dim.classList.toggle('is-on', !!open);
  }
  new MutationObserver(syncDim).observe(document.querySelector('.gc-nav') || document.body, { subtree: true, attributes: true, attributeFilter: ['class'] });
  window.addEventListener('scroll', syncDim, { passive: true });
  function closeAll(except) { items.forEach(function (it) { if (it !== except) { it.classList.remove('is-open'); var b = it.querySelector('.gc-btn'); if (b) b.setAttribute('aria-expanded', 'false'); } }); }
  items.forEach(function (it) {
    var btn = it.querySelector('.gc-btn');
    it.addEventListener('mouseenter', function () { clearTimeout(timer); var cd = document.getElementById('drawer-cart'); if (cd && cd.classList.contains('drawer--visible')) { var cx = cd.querySelector('.drawer__close'); if (cx) cx.click(); } closeAll(it); it.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); if (window.gmDollApply) window.gmDollApply(); });
    it.addEventListener('mouseleave', function () { timer = setTimeout(function () { it.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); }, 380); });
    btn.addEventListener('click', function () { var open = !it.classList.contains('is-open'); closeAll(); it.classList.toggle('is-open', open); btn.setAttribute('aria-expanded', String(open)); });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  document.addEventListener('click', function (e) { if (!e.target.closest('.gc-item')) closeAll(); });
  document.querySelectorAll('.gc-drop--need').forEach(function (d) {
    d.querySelectorAll('[data-gc-need]').forEach(function (n) {
      n.addEventListener('mouseenter', function () {
        var k = n.getAttribute('data-gc-need');
        d.querySelectorAll('[data-gc-need]').forEach(function (x) { x.classList.toggle('is-on', x === n); });
        d.querySelectorAll('[data-gc-panel]').forEach(function (p) { p.classList.toggle('is-on', p.getAttribute('data-gc-panel') === k); });
      });
    });
  });
})();
